export const AUTH_ACTIONS = {
  LOG_IN: "[Authentication - Auth] Log In",
  LOG_OUT: "[Authentication - Auth] Log Out",
};
